import { LOGIN } from '../actions';

const initialState = {
    isSignInForm: 'sign-in',
    dialogLogin: false,
    //// email and facebook login
    authFetching: false,
    firebaseAuth: null,
    firebaseAuthError: null,
    isAuthenticated: false,
    //// reset email
    firebaseResetEmailFetching: false,
    firebaseResetEmail: null,
    //// sf plus
    sfPlusFetching: false,
    firebaseSfPlusUser: null,
    firebaseSfPlusError: null,
    sfPlusChecked: false,
    isSfPlusLinked: false,
    //// vista check balance
    checkBalanceFetching: false,
    chackBalanceData: null,
    checkBalanceError: false,
    chackBalanceDataError: null
};

export default (state = initialState, { type, payload, error }) => {
    switch (type) {
        case LOGIN.OPEN_DIALOG_LOGIN:
            return { ...state, dialogLogin: true, firebaseAuthError: null };

        case LOGIN.FORM_CHANGE:
            return { ...state, isSignInForm: payload, firebaseAuthError: null };

        case LOGIN.FIREBASE_AUTH_PENDING:
            return {
                ...state,
                authFetching: true,
                firebaseAuth: null,
                firebaseAuthError: null
            };

        case LOGIN.FIREBASE_AUTH_SUCCESS:
        case LOGIN.FIREBASE_AUTH_CURRENT_USER:
        case LOGIN.FIREBASE_REGISTER_USER:
        case LOGIN.UPDATE_PROFILE_SUCCESS:
            return {
                ...state,
                dialogLogin: false,
                authFetching: false,
                firebaseAuth: payload,
                isAuthenticated: true
            };

        case LOGIN.FIREBASE_FACEBOOK_AUTH_FAILED:
        case LOGIN.FIREBASE_AUTH_FAILED:
        case LOGIN.UPDATE_PROFILE_FAILED:
            return {
                ...state,
                firebaseAuth: null,
                authFetching: false,
                firebaseAuthError: error,
                isAuthenticated: false
            };

        case LOGIN.CLOSE_DIALOG_LOGIN:
            return {
                ...state,
                isSignInForm: 'sign-in',
                firebaseAuthError: null,
                firebaseResetEmail: null,
                dialogLogin: false
            };

        case LOGIN.FIREBASE_AUTH_SIGNOUT:
            return {
                ...state,
                dialogLogin: false,
                authFetching: false,
                firebaseAuth: null,
                firebaseAuthError: null,
                isAuthenticated: false,
                sfPlusFetching: false,
                firebaseSfPlusUser: null,
                firebaseSfPlusError: null,
                sfPlusChecked: false,
                isSfPlusLinked: false
            };

        case LOGIN.FIREBASE_SF_PLUS_PENDING:
            return {
                ...state,
                sfPlusFetching: true,
                firebaseSfPlusUser: null,
                firebaseSfPlusError: null,
                sfPlusChecked: false
            };

        case LOGIN.FIREBASE_SF_PLUS_SUCCESS:
            return {
                ...state,
                sfPlusFetching: false,
                firebaseSfPlusUser: payload,
                isSfPlusLinked: payload ? true : false
            };

        case LOGIN.FIREBASE_SF_PLUS_FAILED:
            return {
                ...state,
                sfPlusFetching: false,
                firebaseSfPlusUser: null,
                firebaseSfPlusError: error,
                sfPlusChecked: true,
                isSfPlusLinked: false
            };

        case LOGIN.FIREBASE_RESET_EMAIL_PENDING:
            return {
                ...state,
                firebaseResetEmailFetching: true,
                firebaseResetEmail: null,
                firebaseAuthError: null
            };

        case LOGIN.FIREBASE_RESET_EMAIL_SUCCESS:
            return {
                ...state,
                firebaseResetEmailFetching: false,
                firebaseResetEmail: payload
            };

        case LOGIN.FIREBASE_RESET_EMAIL_FAILED:
            return {
                ...state,
                firebaseResetEmailFetching: false,
                firebaseAuthError: error
            };

        case LOGIN.SF_PLUS_CHECK_BALANCE_SUCCESS:
            return {
                ...state,
                sfPlusChecked: true,
                checkBalanceFetching: false,
                chackBalanceData: payload
            };

        case LOGIN.SF_PLUS_CHECK_BALANCE_FAILED:
            return {
                ...state,
                sfPlusChecked: true,
                checkBalanceFetching: false,
                chackBalanceData: null,
                checkBalanceError: true,
                chackBalanceDataError: error
            };

        default:
            return state;
    }
};
